<template>

    <v-layout justify-space-around>

        <button
            tabindex="-1"
            class="help-btn"
            type="button"
            @click="showHelp()"
        >
            ?
        </button>

    </v-layout>

</template>

<script>

import { mapActions } from 'vuex';
import EventBus from '../../modules/EventBus';

export default {
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        prefix: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            required: false,
        },
        white: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        ...mapActions([
            'updateHelp',
        ]),
        showHelp() {
            EventBus.$emit('show-help');
            this.$store.commit('showHelp');
            this.$store.commit('setMezo', this.name);
            if (this.active) {
                this.updateHelp();
            }
        },
    },
};
</script>
<style scoped>
    .help-btn {
        background-color: var(--v-helpColor-base);
        color: var(--v-helpTextColor-base);
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 24px;
        min-height: 24px;
        border-radius: 100%;
        padding-top: 2px;
        font-weight: bold;
    }
    .help-btn:hover {
        background-color: var(--v-activeHelpColor-base);
        color: var(--v-activeHelpTextColor-base);
    }
</style>
